import React, { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel, TabPanels, Box } from '@chakra-ui/react';
import VendorBalance from './vendorbalance';
import VendorInvoice from './vendorinvoice';
import VendorAdvances from './vendoradvances';

const Vendor = () => {
	const [tabIndex, setTabIndex] = useState(0);
	const handleSwitchToAdvance = () => {
		setTabIndex(2); // Index of 'Vendor Advances' tab
	}
	return (
		<Box w='100%'>
			<Tabs
				index={tabIndex}
				onChange={(index) => setTabIndex(index)}
				bg='white'
				boxShadow='md'
				border='none'
				borderRadius='0px 0px 5px 5px'
				size='lg'
				isManual
				variant='enclosed'>
				<TabList
					bg='var(--chakra-colors-mainBlueColor)'
					boxShadow='0px 4px 4px rgba(0, 0, 0, 0.25)'
					color='white'
					padding='10px 15px'>
					<Tab
						_selected={{
							color: 'var(--chakra-colors-mainBlueColor)',
							bg: 'white',
						}}
						fontSize='1.4rem'
						borderRadius='5px'
						fontWeight='600'>
						Vendor Balance
					</Tab>
					<Tab
						_selected={{
							color: 'var(--chakra-colors-mainBlueColor)',
							bg: 'white',
						}}
						fontSize='1.4rem'
						borderRadius='5px'
						fontWeight='600'>
						Vendor Invoice
					</Tab>
					<Tab
						isDisabled
						_selected={{
							color: 'white',
							bg: 'green',
						}}
						fontSize='1.4rem'
						borderRadius='5px'
						fontWeight='600'>
						Vendor Advances
					</Tab>
				</TabList>

				<TabPanels>
					<TabPanel>
						<VendorBalance />
					</TabPanel>
					<TabPanel>
						<VendorInvoice onAdvanceClick={handleSwitchToAdvance} />
					</TabPanel>
					<TabPanel>
						<VendorAdvances />
					</TabPanel>
				</TabPanels>
			</Tabs>
		</Box>
	);
};

export default Vendor;
